// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ElevateButton-elevated {\n  color: var(--tru-blue);\n}", "",{"version":3,"sources":["webpack://./components/ElevateButton/index.sass"],"names":[],"mappings":"AACE;EACE,sBAAA;AAAJ","sourcesContent":[".ElevateButton\n  &-elevated\n    color: var(--tru-blue)\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
